import { ProfilePageTranslations } from "./types";

export const enTranslations: ProfilePageTranslations = {
    goBack: "Go Back",
    heading:"Profile",
    email: "Email",
    user: "User",
    dfn: "DFN",
    institution:"Institution",
    role:"Role",
    dateCreated:"Date created",
    gamesPlayed:"Games played",
    patientsSeen:"Patients seen",
    currentLicense:"Current license",
    licenseExpiryDate:"License expiry Date",
    changePassword:"Change Password",
    seeBadges: "See Badges",
    seeClasses: "See Classes"
}